const messages = {
    nl: {
        account: {
            account_settings: 'Account instellingen',
            change_email: 'Aanpassen email',
            change_email_info: 'Vul onderstaand je nieuwe e-mailadres in.<br>We sturen een e-mail naar het nieuwe adres ter verificatie.',
            delete_account: 'Verwijder account',
            delete_account_info: {
                header: 'Je account en persoonlijke informatie worden permanent verwijderd.',
                body: 'Data die wordt verwijderd omvat:',
                list: [
                    'Je persoonlijke informatie',
                    'Sollicitaties op vacatures in ons system (niet de data die een werkgever gedownload kan hebben).',
                    'CV’s, inclusief de zoekresultaten van de werkgever.',
                    'Marketing and job alert e-mails',
                ],
                footer: 'Het is mogelijk om na het verwijderen van dit account een nieuw account aan te maken.',
            },
            delete_confirmation: 'Weet je het zeker? Het verwijderen kan niet ongedaan worden gemaakt.',
            delete_success_title: 'Jammer dat je gaat.',
            delete_success_message: 'Je account is succesvol verwijderd. Je bent nu uitgelogd.',
            enter_code: 'Vul de code in',
            resend_code: 'Verstuur de code opnieuw',
            reset_password: 'Reset wachtwoord',
            reset_password_info: 'Klik op onderstaande button en we sturen je een code om je wachtwoord te resetten. Daarna kun je een nieuw wachtwoord instellen.',
            reset_password_success: 'We hebben een code gestuurd om je wachtwoord te resetten. Niet ontvangen? Check ook even je spam. Klik hier om de code nog eens te versturen.',
            try_again: 'probeer het over 10 minuten opnieuw.',
        },

        api_message: {
            UserTokenNotFoundException: 'Het lijkt er op dat de token ongeldig is.',
            ValidationCaptchaException: 'Het lijkt er op dat de Google Captcha ongeldig is.',
            ValidationException: 'Het lijkt er op dat sommige velden onjuist zijn ingevuld.',
            InvalidAuthenticationException: 'Check je e-mail en wachtwoord en probeer het opnieuw.',
            MaxAttemptsException: 'Max aantal pogingen overschreden. ',
            ResourceNotFoundException: 'Verzoek niet gevonden.',
            UserNotFoundException: 'Gebruiker niet gevonden.',
            SeekerNotFoundException: 'We herkennen het e-mailadres niet. Probeer het alsjeblieft opnieuw.',
            SeekerEmailResetNotFoundException: 'De reset token is ongeldig.',
            EmailTokenNotValidException: 'De token is ongeldig.',
            QueryException: 'Er ging iets verkeerd',
            ServerErrorException: 'Er ging iets verkeerd.',
            UserConfirmationTokenNotFoundException: 'De token is ongeldig.',
            UserExistsException: 'Dit e-mailadres is al in gebruik.',
            JobNotFoundException: 'Deze vacature is niet meer beschikbaar.',
            UserResumeNotFoundException: 'Dit CV bestaat niet meer.',
            UserJobAlertNotFoundException: 'Deze job alert bestaat niet meer.',
            UserAppliedForJobException: 'Je hebt al op deze functie gesolliciteerd.',
            PromotionNotFoundException: 'Het lijkt er op dat deze actie niet bestaat.',
            SmartfeedJobTokenNotFoundException: 'De sollicitatie token is niet geldig.',
            InvalidPasswordException: 'Je wachtwoord is ongeldig.',
            OwnEmailNotAllowedException: 'Je kunt niet wisselen naar je huidige e-mail.',
            FileImageSizeException: 'De afbeelding is te klein. Minimale afbeeldingsgrootte is 150x150px.',
            FileSizeException: 'Het bestand is te groot. Maximale bestandsgrootte is 20MB.',
            GoogleCaptchaException: 'Google captcha kan niet worden gevalideerd.',
            SeekerPasswordResetNotFoundException: 'Vul de reset code nogmaals in en probeer het opnieuw.',
            InvalidFilterCriteria: 'Deze zoekopdracht is te breed. Geef een aantal criteria op.',
            PasswordResetTooManyAttempts: 'Te veel wachtwoord reset pogingen. Probeer het over 20 seconden opnieuw.',
            PasswordTokenNotValid: 'Wachtwoord code is niet geldig.',
        },

        additional_document: {
            drag_and_drop_info: 'Sleep een bestand hier <br> om je aanvullende documenten te uploaden',
            file_type_info: 'Only .docx, .doc, .pdf file is allowed',
            max_document_size_info: 'Maximale bestandsgrootte is 10MB',
            not_found: 'Geen overige documenten gevonden',
            remove: 'Remove additional document?',
            title: 'Aanvullende documenten',
            uploaded: 'Uploaded',
            uploaded_documents: 'Geüploade documenten',
        },

        application: {
            title: 'Sollicitaties',
            not_found: 'Geen sollicitaties gevonden',
            view: 'Bekijk vacature',
        },

        apply: {
            apply_with_email_title: 'Of solliciteer met je e-mail adres',
            action: 'Solliciteer',
            apply_for_job: 'Solliciteer op deze vacature',
            apply_as_guest: 'Doorgaan als gast',
            info: 'We maken automatisch een profiel aan vanuit het account naar keuze om te solliciteren.',
            apply_with_email: 'Solliciteer met {email}',
            apply_with_linkedin: 'Solliciteer met Linkedin',
            back: 'Terug naar de vacatures',
            confirmation: 'Een bevestiging is gestuurd naar',
            job_application: 'Sollicitatie',
            loading_resume: 'We zijn je CV aan het uploaden. Een momentje alsjeblieft...',
            success: 'Bedankt voor je sollicitatie',
            title: 'Solliciteer met je account',
            register_and_apply: 'Register and Apply',
            application_already_received: 'Application already received',
        },

        cover_letter: {
            add: 'Voeg een motivatiebrief toe',
            apply_without: 'Solliciteer zonder motivatiebrief',
            drag_and_drop_info: 'Sleep een bestand hier  om je  Motivatiebrief te uploaden',
            edit: 'Pas je motivatiebrief aan',
            file_type_info: 'Only .docx, .doc, .pdf file is allowed',
            max_document_size_info: 'Max resume size is 10MB',
            not_found: 'Geen opgeslagen brieven',
            remove: 'Motivatiebrief verwijderen?',
            title: 'Motivatiebrief',
            uploaded: 'Geüpload op {date}',
            uploaded_documents: 'Uploaded cover letters',
            write_new: 'Schrijf een nieuwe motivatie',
        },

        dashboard_menu: {
            applications: 'Sollicitaties',
            saved_jobs: 'Bewaarde vacatures',
            job_alerts: 'Job alerts',
            profile_details: 'Mijn profiel',
            work_preferences: 'Voorkeuren',
            documents: 'Documenten',
            account_settings: 'Account instellingen',
            logout: 'Uitloggen',
        },

        filter: {
            clear_all: 'Wis alles',
            info: 'User search above to find more',
            see_less: 'Minder weergeven',
            see_all_value: 'Zie alle {value} filters',
        },

        forgot_password: {
            title: 'Wachtwoord vergeten',
            info: 'Vul je e-mailadres in en we sturen je een code om je wachtwoord te resetten als er een account bestaat.',
            resend_code: 'Klik hier om de code nogmaals te versturen',
            success: 'We hebben een code gestuurd naar onderstaand adres. Niets ontvangen? Check ook even je spam.',
            success_resend_code: 'We hebben de herstelcode verstuurd naar onderstaand adres. Check ook even je spam.',
            try_again: 'Probeer het over {countDown} seconden opnieuw',
        },

        create_password: {
            title: 'Create password',
            info: 'Welcome back! It looks like your password has expired. We’ve emailed you a reset password pin. Please enter your pin and reset your password below.',
        },

        global: {
            currency_format: '€{0}',
            currency_symbol: '€',
        },

        job_alert: {
            create: 'Maak een job alert',
            error: 'We kunnen de job alert niet aanmaken. Refresh de pagina en prober opnieuw.',
            manage: 'Beheer jouw job alerts',
            not_found: 'Geen opgeslagen job alert gevonden.',
            remove: 'Deze job alert verwijderen?',
            save: 'Bewaar job alert',
            saved: 'Opgeslagen job alerts',
            search_term: 'Zoekterm',
            success: 'Je job alert is aangemaakt, bedankt!',
            success_remove: 'Je job alert is verwijderd. Dank u',
            title: 'Job alerts',
        },

        job_view: {
            date_posted: 'Plaatsingsdatum',
            expired: 'Deze vacature is verlopen',
            expired_desc: 'This job is no longer available. Please view our full list of jobs by clicking \'See more results\'.',
            posted_on: 'Geplaatst op',
            see_desc: 'Zie de vacature omschrijving',
            hide_desc: 'Verberg de vacature omschrijving',
            other_jobs: 'Andere vergelijkbare vacatures',
        },

        single_job: {
            backToSearchUrl: 'vacatures',
            see_more_results: 'Meer resultaten',
            see_more_results_2: 'Back To All Jobs',
        },

        label: {
            add_all: 'Voeg jouw interesses toe: {value}',
            add_value: 'Voeg {value} toe',
            additional_documents: 'Overige documenten',
            alert_name: 'Alert naam',
            alert_name_placeholder: 'Zoekterm',
            already_have_account: 'Already have an account?',
            annual_salary: 'Jaarsalaris',
            annualy: 'Jaarlijks',
            any: 'Elke',
            any_value: 'Elke {value}',
            apply_again: 'Solliciteer opnieuw',
            apply_as_guest: 'Doorgaan als gast',
            apply_for_this_job: 'Solliciteer op deze vacature',
            apply_now: 'Solliciteer nu',
            quick_apply: 'Snel aanvragen',
            availability: 'Beschikbaarheid',
            back: 'Terug',
            back_to_value: 'Terug naar {value}',
            base_pay: 'Base pay',
            basic_information: 'Basis informatie',
            cancel: 'Annuleren',
            career_level: 'Carrièreniveau',
            certifications: 'Certificeringen',
            change_email: 'Verander e-mail',
            classification: 'Vakgebied',
            company: 'Bedrijf',
            company_placeholder: 'Vul hier de bedrijfsnaam in',
            company_size: 'Bedrijfsgrootte',
            confirm_password: 'Bevestig wachtwoord',
            confirm_remove: 'Ja, verwijderen',
            consultant: 'Consultant',
            contact_number: 'Telefoonnummer',
            contact_number_placeholder: 'Enter contact number',
            continue_to_apply: 'Ga door met solliciteren',
            contract_type: 'Contract type',
            country: 'Country',
            country_of_citizenship: 'Country of citizenship',
            course_name: 'Cursus naam',
            cover_letter: 'Motivatiebrief',
            cover_letter_custom_name: 'Voeg een eigen title toe',
            cover_letter_name: 'Titel motivatiebrief',
            cover_letters: 'Begeleidend schrijven',
            create: 'Aanmaken',
            create_job_alert: 'Maak een job alert',
            current_role: 'Huidige rol',
            daily: 'Dagelijks',
            date_posted: 'Plaatsingsdatum',
            delete_my_account: 'Verwijder mijn account',
            description: 'Omschrijving',
            desired_occupations: 'Gewenste functies',
            desired_pay: 'Gewenst salaris',
            desired_work_locations: 'Gewenste locaties',
            dob: 'Geboortedatum',
            dont_have_account: 'Nog geen account?',
            download: 'Download',
            edit: 'Bewerken',
            edit_value: 'Bewerken {value}',
            education: 'Opleiding',
            email: 'E-mail',
            email_address: 'E-mailadres',
            email_address_placeholder: 'E-mailadres',
            email_alert_frequency: 'E-mail alert frequentie',
            email_me_code: 'E-mail mij de code',
            email_to: 'E-mail naar',
            emergency_contact_name: 'Contactpersoon in geval van nood',
            emergency_contact_number: 'Contactnummer voor noodgevallen',
            emergency_contact_rel: 'Contactrelatie voor noodgevallen',
            end_date: 'Sluitingsdatum',
            enter_code: 'Vul de code in',
            enter_current_password: 'Vul je huidige wachtwoord in',
            enter_current_password_for_email: 'Vul je huidige wachtwoord in om je e-mailadres te veranderen.',
            enter_new_email: 'Vul je nieuwe e-mailadres in',
            enter_new_password: 'Vul je nieuwe wachtwoord in',
            enter_the_value: 'Vul {value} in',
            enter_value: 'Vul {value} in',
            enter_your_value: 'Vul jouw {value} in',
            enter_your_value_again: 'Vul jouw {value} nogmaals in',
            expires_at: 'Closing date',
            filters: 'Filters',
            find_jobs_now: 'Vind nu vacatures',
            first_name: 'Voornaam',
            forgot_password: 'Wachtwoord vergeten',
            frequency: 'Frequentie',
            gender: 'Geslacht',
            go: 'Ga',
            home_location: 'Woonplaats',
            hourly: 'Per uur',
            hourly_rate: 'Uurtarief',
            in_progress: 'In behandeling',
            industries: 'Industrieën waarin je wil werken',
            institution_name: 'Bedrijfsnaam',
            is_contactable: 'May we contact this referee?',
            is_report_directly: 'Did you report directly to this referee?',
            job_mode: 'Job mode',
            job_title: 'Functienaam',
            job_title_placeholder: 'Vul hier jouw functie in bijv. Accountant',
            job_type: 'Functietype',
            job_type_placeholder: 'Selecteer een functie type',
            keyword: 'Zoekterm(en)',
            languages: 'Talen',
            last_name: 'Achternaam',
            last_name_placeholder: 'Enter last name',
            licenses_and_certifications: 'Licenties en certificaten',
            licenses_or_certifications: 'Licenties of certificaten',
            location: 'Locatie',
            login: 'Login',
            look_for_all_jobs: 'Kijk voor alle beschikbare vacatures',
            max: 'Maximaal',
            message: 'Bericht',
            min: 'Minimaal',
            mobile_number: 'Mobile number',
            mobile_number_placeholder: 'Enter mobile number',
            modified: 'Gewijzigd',
            new_cover_letter_details: 'Nieuwe sollicitatiebrief details',
            no_industries: 'Ik heb geen voorkeur voor een sector.',
            no_job_mode: 'Ik heb geen job mode voorkeur',
            not_added_value: 'Geen {value} ingevuld',
            not_found: 'Niet gevonden',
            null_pay_included: 'Vacatures opnemen die geen salarisgegevens hebben',
            occupation: 'Functie',
            occupation_placeholder: 'Vul hier functies in waarin je geïnteresseerd bent',
            off: 'Uitschakelen',
            password: 'Wachtwoord',
            payband_placehoder: 'Select the closest value',
            per_day: 'Per dag',
            perks_and_benefits: 'Secundaire voorwaarden',
            phone_number: 'Phone number',
            phone_number_placeholder: 'Enter phone number',
            placeholder_email: 'email',
            placeholder_password: 'password',
            position: 'Position',
            position_placeholder: 'Enter position',
            print: 'Print',
            profession: 'Beroep',
            profile_picture: 'Profielfoto',
            qualification_type: 'Kwalificatie type',
            range: 'Bereik',
            recover_password: 'Wachtwoord herstellen',
            reference: 'Aanbeveling',
            reference_number: 'Referentienummer',
            register: 'Registreren',
            register_and_apply: 'Registreren en solliciteren',
            relevance: 'Relevantie',
            remove: 'Verwijderen',
            required_value: 'Dit {value} is verplicht',
            reset: 'Opnieuw instellen',
            reset_password: 'Wachtwoord opnieuw instellen',
            resumes: 'cv’s',
            salary: 'Salaris',
            salary_type: 'Salaristype',
            salary_currency: 'Salaris valuta',
            salary_any_currency: 'Elke valuta',
            save: 'Opslaan',
            save_cover_letter: 'Motivatiebrief opslaan',
            save_job: 'Vacature opslaan',
            save_value: '{value} opslaan',
            save_work_experience: 'Werkervaring opslaan',
            search_by_location: 'Zoeken op locatie',
            search_jobs: 'Zoek vacatures',
            search_keyword: 'Zoekterm',
            search_within_value: '`Zoek in {value1} {value2}',
            sector: 'Sector',
            select_location: 'All locations',
            select_value: 'Selecteer {value}',
            share: 'Share',
            sign_in: 'Inloggen',
            sign_in_and_apply: 'Aanmelden en Solliciteren',
            skills: 'Skills',
            sort_by: 'Sorteren op',
            start_date: 'Start datum',
            start_end_dates: 'Start- en einddatum',
            sub_classification: 'Subclassificatie',
            sub_classification_select: 'Select subclassifications',
            submit: 'Submit',
            suburb_city_area: 'Plaats',
            unsave: 'Niet opslaan of ongedaan maken',
            upload_file_size: 'File size 10MB max',
            upload_label: 'Tap to upload document',
            upload_new: 'Upload new',
            upload_new_additional_document: 'Nieuw overige documenten uploaden',
            upload_new_cover_letter: 'Nieuw begeleidend schrijven uploaden',
            upload_new_resume: 'Nieuw CV uploaden',
            upload_profile_picture: 'Upload profielfoto',
            uploaded: 'Uploaded',
            uploaded_document: 'Uploaded document',
            uploaded_now: 'just now',
            view_job: 'Bekijk vacature',
            weekly: 'Wekelijks',
            what_is_this: 'Wat is dit',
            what_is_this_occupation: 'Dit gebruiken wij om een goede functie te matchen. Selecteer de functie die het beste past bij jouw voorkeuren.',
            work_authorisation: 'Work authorisation',
            work_experience: 'Werkervaring',
            work_location: 'Werklocatie',
            work_occupation_placeholder: 'Vul uw beroep in',
            work_preferences: 'Voorkeuren',
            work_type: 'Type vacature',
            write_a_cover_letter: 'Schrijf een motivatie',
            write_cover_letter: 'Schrijf een motivatie',
        },

        login: {
            welcome_back: 'Welkom terug',
            welcome: 'Welkom',
            title: 'Log in',
            info: '',
            back: 'Back to log in',
        },

        profile: {
            basic_information: 'Basis informatie',
            not_found_location: 'We ondersteunen momenteel geen vacatures op deze locatie. Neem contact met ons op om een ​​nieuwe locatie aan te vragen.',
            not_found_global_location: 'Geen overeenkomende locaties gevonden. Probeer een andere zoekopdracht of selecteer Land als locatie.',
            pay_info: 'Your pay information helps us to better understand your career history, so we can focus on progressing your career.',
            profile_details: 'Profiel details',
        },

        raw: {
            sorry_there_were_no_jobs_found_for_that_search_criteriabrjobs_you_may_still_be_interested_in: 'Helaas, er zijn geen vacatures gevonden die aan deze criteria voldoen.',
            override_search_title: 'Vacatures',
        },
        register: {
            welcome: 'Welkom!',
            welcome_aboard: 'Welkom',
            info: 'Creëer een account in een paar seconden',
            back: 'Terug om in te loggen',
        },

        reset_email: {
            title: 'Reset e-mail',
            success: 'Je e-mail is gereset',
        },

        reset_password: {
            title: 'Wachtwoord aanmaken',
            info: 'Vul hier je e-mailadres in dat is gekoppeld aan dit account met het nieuwe wachtwoord.',
            success: 'Je wachtwoord is succesvol aangemaakt!',
        },

        resume: {
            apply_without: 'Solliciteer zonder CV',
            default: 'Standaard CV',
            dropbox_title: 'Upload via Dropbox',
            default_option: 'Maak dit mijn standaard CV',
            default_text: 'Selecteer optie voor CV',
            drag_and_drop_info: 'Sleep een bestand hier <br> om je CV te uploaden.',
            drag_and_drop_size: '(Bestandsgrootte maximaal 10MB)',
            file_type_info: 'Alleen .docx, .doc, .pdf, .rtf, .txt, .odt, .pages zijn toegestaan',
            googledrive_title: 'Upload via Google Drive',
            max_resume_size_info: 'Maximale bestandsgrootte is 10MB',
            new: 'Upload nieuw CV',
            not_found: 'Geen CV’s geüpload.',
            remove: 'CV verwijderen?',
            title: 'CV’s',
            upload_documents: 'Documenten uploaden',
            upload: 'CV uploaden',
            uploaded: 'Geüpload',
            uploaded_resumes: 'Toegevoegde CV’s',
            upload_via: 'Upload via {service}',
            ducment_uploaded: 'Document uploaded',
        },

        saved_job: {
            saved_jobs: 'Opgeslagen vacatures',
            not_found: 'Geen opgeslagen vacatures gevonden',
        },

        search_results: {
            not_found: 'Helaas, er zijn geen vacatures gevonden die aan deze criteria voldoen.',
            showing: '',
            separator: '-',
            of: 'van',
            results: 'resultaten',
                        listView: 'List View',
            mapView: 'Map View',
            mapViewLocation: 'Location',
            mapViewRadius: 'Within (KM)',
            mapViewUpdate: 'Update Map',
            mapViewReset: 'Reset Map',
        },

        share: {
            facebook: 'Post',
            linkedin: 'Share',
            title: 'Delen via',
            twitter: 'Tweet',
        },

        terms: {
            link: 'Bij doorgaan ga je akkoord met',
            and: 'en',
            terms: 'Gebruikersvoorwaarden',
            privacy: 'Privacy Policy',
            validation_message: 'Please agree to our terms and conditions',
        },

        work_preferences: {
            work_preferences: 'Werkvoorkeuren',
            next_role: 'Jouw volgende functie',
            other: 'Andere voorkeuren',
            job_type: 'Type vacature',
            contract_type: 'Type contract',
        },

        work_experience: {
            add: 'Werkervaring toevoegen?',
            edit: 'Werkervaring toevoegen?',
            remove: 'Werkervaring verwijderen?',
        },

        education: {
            add: 'Add education',
            remove: 'Remove education',
        },

        reference: {
            add: 'Add referee',
            remove: 'Remove referee',
        },

        searchbar: {
            keywords_label: 'Zoekterm',
            classifications_label: 'Vakgebied',
            classification_placeholder: 'in all Vakgebied',
            locations_label: 'Locatie',
        },

        screening: {
            confirm_and_finish: 'Bevestig en voltooi',
            title: 'Vul aanvullende vragen in',
            sub_title: 'Vergroot uw kansen om in aanmerking te komen voor deze baan door de onderstaande vragen in te vullen',
        },

        networks: {
            facebook: {
                shareText: 'Post',
            },
            twitter: {
                shareText: 'Tweet',
            },
            linkedin: {
                shareText: 'Share',
            },
        },
    },
};

export default messages;
